// Textos de reportsPon (FE-03a, R06). Ligado em DICT.<lang>.app.reportsPon; lido por `useApp().t.app.reportsPon`.
// Relatórios de portas PON: Ocupação (tabela + gráficos) e Diagrama (matriz slot × porta).

const pt = {
  locale: 'pt-BR',
  backToHub: '← Central de Relatórios',
  refresh: 'Atualizar',
  requestFailed: 'Falha na requisição.',
  allOlts: 'Todas as OLTs',
  allZones: 'Todas as zonas',
  allStatus: 'Todos os status',
  occRange: 'Faixa de ocupação',
  onlySaturated: 'Só saturadas',
  occLegend: 'ocupação da porta',
  kpi: {
    ports: 'Portas PON', active: 'Portas ativas', avg: 'Ocupação média',
    saturated: 'Saturadas (>90%)', idle: 'Ociosas (<10%)', occCap: 'Ocupado / capacidade',
  },
  band: { saturated: 'Saturada', high: 'Alta', moderate: 'Moderada', idle: 'Ociosa' },
  col: {
    olt: 'OLT', slotPort: 'Slot/Porta', name: 'Nome', zone: 'Zona', status: 'Status',
    onus: 'ONUs on/total', capacity: 'Capacidade', occupancy: 'Ocupação', avgRx: 'Rx médio', throughput: 'Throughput',
  },
  xlsx: {
    portsSheet: 'Portas PON',
    summarySheet: 'Resumo por OLT',
    capacityPorts: ['OLT', 'Fabricante', 'Slot/Porta', 'Nome', 'Zona', 'Status', 'ONUs online', 'ONUs total', 'Capacidade', 'Ocupação %', 'Rx médio (dBm)', 'Throughput (bps)', 'Última coleta'],
    capacitySummary: ['OLT', 'Portas', 'Capacidade', 'Ocupadas', 'Livres', 'Ocupação média %', 'Saturadas'],
    diagramPorts: ['OLT', 'Slot/Porta', 'Nome', 'Zona', 'Status', 'ONUs online', 'ONUs total', 'Capacidade', 'Ocupação %', 'Faixa'],
    diagramSummary: ['OLT', 'Portas', 'Ocupação média %', 'Saturadas (>90%)'],
  },
  capacity: {
    title: 'Ocupação de portas PON',
    subtitle: 'Capacidade utilizada versus disponível em cada porta PON da frota, com ranking das mais cheias e distribuição de ocupação. Ocupação = ONUs provisionadas ÷ capacidade da porta.',
    toDiagram: 'Ver no diagrama',
    topTitle: 'Top 20 portas mais cheias',
    portsHint: (n) => `${n} portas`,
    emptyChart: 'Sem portas no filtro.',
    tooltipOcc: 'Ocupação',
    histTitle: 'Distribuição de ocupação',
    histHint: 'portas por faixa',
    tooltipPorts: 'Portas',
    histLabel: (l) => `Ocupação ${l}%`,
    byOltTitle: 'Ocupado × livre por OLT',
    oltsHint: (n) => `${n} OLTs`,
    occupied: 'Ocupado',
    free: 'Livre',
    tableEmpty: 'Nenhuma porta PON no filtro atual.',
    footer: (a, b) => `${a} de ${b} portas · capacidade padrão GPON 128 quando a porta não informa um limite.`,
  },
  diagram: {
    title: 'Diagrama de portas PON',
    subtitleA: 'Uma matriz slot × porta por OLT — cada célula é uma porta PON, colorida pela ocupação (verde → vermelho) com ',
    subtitleB: '. Clique numa porta para ver as ONUs.',
    toTable: 'Ver na tabela',
    detailed: 'Detalhado',
    compact: 'Compacto',
    loading: 'Carregando portas PON…',
    noPorts: 'Nenhuma porta PON no filtro atual.',
    portsCount: (n) => `${n} portas`,
    avgBadge: (n) => `${n}% médio`,
    cellLine2: (on, tot, cap, pct, band) => `${on}/${tot} ONUs · cap ${cap} · ${pct}% (${band})`,
    cellRx: (v) => `Rx médio ${v} dBm`,
    drawerHint: 'Clique numa porta da matriz para ver os detalhes e as ONUs.',
    ponTitle: (olt, label) => `${olt} · PON ${label}`,
    occDetail: (on, tot, cap, pct, band) => `${on}/${tot} · cap ${cap} · ${pct}% (${band})`,
    openPort: 'Abrir porta',
    portOnus: 'ONUs da porta',
    loadingOnus: 'Carregando ONUs…',
    noOnus: 'Nenhuma ONU nesta porta.',
    on: 'on',
    off: 'off',
  },
};

const en = {
  locale: 'en-US',
  backToHub: '← Reports Center',
  refresh: 'Refresh',
  requestFailed: 'Request failed.',
  allOlts: 'All OLTs',
  allZones: 'All zones',
  allStatus: 'All statuses',
  occRange: 'Occupancy range',
  onlySaturated: 'Saturated only',
  occLegend: 'port occupancy',
  kpi: {
    ports: 'PON ports', active: 'Active ports', avg: 'Average occupancy',
    saturated: 'Saturated (>90%)', idle: 'Idle (<10%)', occCap: 'Used / capacity',
  },
  band: { saturated: 'Saturated', high: 'High', moderate: 'Moderate', idle: 'Idle' },
  col: {
    olt: 'OLT', slotPort: 'Slot/Port', name: 'Name', zone: 'Zone', status: 'Status',
    onus: 'ONUs on/total', capacity: 'Capacity', occupancy: 'Occupancy', avgRx: 'Avg Rx', throughput: 'Throughput',
  },
  xlsx: {
    portsSheet: 'PON ports',
    summarySheet: 'Summary by OLT',
    capacityPorts: ['OLT', 'Vendor', 'Slot/Port', 'Name', 'Zone', 'Status', 'ONUs online', 'ONUs total', 'Capacity', 'Occupancy %', 'Avg Rx (dBm)', 'Throughput (bps)', 'Last poll'],
    capacitySummary: ['OLT', 'Ports', 'Capacity', 'Used', 'Free', 'Average occupancy %', 'Saturated'],
    diagramPorts: ['OLT', 'Slot/Port', 'Name', 'Zone', 'Status', 'ONUs online', 'ONUs total', 'Capacity', 'Occupancy %', 'Band'],
    diagramSummary: ['OLT', 'Ports', 'Average occupancy %', 'Saturated (>90%)'],
  },
  capacity: {
    title: 'PON port occupancy',
    subtitle: 'Used versus available capacity on every PON port in the fleet, with a ranking of the fullest ones and the occupancy distribution. Occupancy = provisioned ONUs ÷ port capacity.',
    toDiagram: 'View in diagram',
    topTitle: 'Top 20 fullest ports',
    portsHint: (n) => `${n} ports`,
    emptyChart: 'No ports in the filter.',
    tooltipOcc: 'Occupancy',
    histTitle: 'Occupancy distribution',
    histHint: 'ports per range',
    tooltipPorts: 'Ports',
    histLabel: (l) => `Occupancy ${l}%`,
    byOltTitle: 'Used × free per OLT',
    oltsHint: (n) => `${n} OLTs`,
    occupied: 'Used',
    free: 'Free',
    tableEmpty: 'No PON port in the current filter.',
    footer: (a, b) => `${a} of ${b} ports · default GPON capacity of 128 when the port does not report a limit.`,
  },
  diagram: {
    title: 'PON port diagram',
    subtitleA: 'A slot × port matrix per OLT — each cell is a PON port, colored by occupancy (green → red) with ',
    subtitleB: '. Click a port to see its ONUs.',
    toTable: 'View in table',
    detailed: 'Detailed',
    compact: 'Compact',
    loading: 'Loading PON ports…',
    noPorts: 'No PON port in the current filter.',
    portsCount: (n) => `${n} ports`,
    avgBadge: (n) => `${n}% avg`,
    cellLine2: (on, tot, cap, pct, band) => `${on}/${tot} ONUs · cap ${cap} · ${pct}% (${band})`,
    cellRx: (v) => `Avg Rx ${v} dBm`,
    drawerHint: 'Click a port in the matrix to see its details and ONUs.',
    ponTitle: (olt, label) => `${olt} · PON ${label}`,
    occDetail: (on, tot, cap, pct, band) => `${on}/${tot} · cap ${cap} · ${pct}% (${band})`,
    openPort: 'Open port',
    portOnus: 'Port ONUs',
    loadingOnus: 'Loading ONUs…',
    noOnus: 'No ONU on this port.',
    on: 'on',
    off: 'off',
  },
};

const es = {
  locale: 'es-ES',
  backToHub: '← Centro de Reportes',
  refresh: 'Actualizar',
  requestFailed: 'Falló la solicitud.',
  allOlts: 'Todas las OLTs',
  allZones: 'Todas las zonas',
  allStatus: 'Todos los estados',
  occRange: 'Rango de ocupación',
  onlySaturated: 'Solo saturadas',
  occLegend: 'ocupación del puerto',
  kpi: {
    ports: 'Puertos PON', active: 'Puertos activos', avg: 'Ocupación media',
    saturated: 'Saturados (>90%)', idle: 'Ociosos (<10%)', occCap: 'Ocupado / capacidad',
  },
  band: { saturated: 'Saturado', high: 'Alto', moderate: 'Moderado', idle: 'Ocioso' },
  col: {
    olt: 'OLT', slotPort: 'Slot/Puerto', name: 'Nombre', zone: 'Zona', status: 'Estado',
    onus: 'ONUs on/total', capacity: 'Capacidad', occupancy: 'Ocupación', avgRx: 'Rx medio', throughput: 'Throughput',
  },
  xlsx: {
    portsSheet: 'Puertos PON',
    summarySheet: 'Resumen por OLT',
    capacityPorts: ['OLT', 'Fabricante', 'Slot/Puerto', 'Nombre', 'Zona', 'Estado', 'ONUs online', 'ONUs total', 'Capacidad', 'Ocupación %', 'Rx medio (dBm)', 'Throughput (bps)', 'Última lectura'],
    capacitySummary: ['OLT', 'Puertos', 'Capacidad', 'Ocupados', 'Libres', 'Ocupación media %', 'Saturados'],
    diagramPorts: ['OLT', 'Slot/Puerto', 'Nombre', 'Zona', 'Estado', 'ONUs online', 'ONUs total', 'Capacidad', 'Ocupación %', 'Franja'],
    diagramSummary: ['OLT', 'Puertos', 'Ocupación media %', 'Saturados (>90%)'],
  },
  capacity: {
    title: 'Ocupación de puertos PON',
    subtitle: 'Capacidad utilizada frente a disponible en cada puerto PON de la flota, con ranking de los más llenos y distribución de la ocupación. Ocupación = ONUs aprovisionadas ÷ capacidad del puerto.',
    toDiagram: 'Ver en el diagrama',
    topTitle: 'Top 20 puertos más llenos',
    portsHint: (n) => `${n} puertos`,
    emptyChart: 'Sin puertos en el filtro.',
    tooltipOcc: 'Ocupación',
    histTitle: 'Distribución de la ocupación',
    histHint: 'puertos por franja',
    tooltipPorts: 'Puertos',
    histLabel: (l) => `Ocupación ${l}%`,
    byOltTitle: 'Ocupado × libre por OLT',
    oltsHint: (n) => `${n} OLTs`,
    occupied: 'Ocupado',
    free: 'Libre',
    tableEmpty: 'Ningún puerto PON en el filtro actual.',
    footer: (a, b) => `${a} de ${b} puertos · capacidad estándar GPON 128 cuando el puerto no informa un límite.`,
  },
  diagram: {
    title: 'Diagrama de puertos PON',
    subtitleA: 'Una matriz slot × puerto por OLT — cada celda es un puerto PON, coloreada por la ocupación (verde → rojo) con ',
    subtitleB: '. Haga clic en un puerto para ver las ONUs.',
    toTable: 'Ver en la tabla',
    detailed: 'Detallado',
    compact: 'Compacto',
    loading: 'Cargando puertos PON…',
    noPorts: 'Ningún puerto PON en el filtro actual.',
    portsCount: (n) => `${n} puertos`,
    avgBadge: (n) => `${n}% medio`,
    cellLine2: (on, tot, cap, pct, band) => `${on}/${tot} ONUs · cap ${cap} · ${pct}% (${band})`,
    cellRx: (v) => `Rx medio ${v} dBm`,
    drawerHint: 'Haga clic en un puerto de la matriz para ver los detalles y las ONUs.',
    ponTitle: (olt, label) => `${olt} · PON ${label}`,
    occDetail: (on, tot, cap, pct, band) => `${on}/${tot} · cap ${cap} · ${pct}% (${band})`,
    openPort: 'Abrir puerto',
    portOnus: 'ONUs del puerto',
    loadingOnus: 'Cargando ONUs…',
    noOnus: 'Ninguna ONU en este puerto.',
    on: 'on',
    off: 'off',
  },
};

export const REPORTS_PON_I18N = { pt, en, es };
